import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditUserComponent } from '@app/core/windows'; 


@Component({
  selector: 'users-crud',
  templateUrl: './users-crud.component.html',
  providers: [ DatasourceService ]  
})
export class UsersCrudComponent extends BaseCrudComponent implements OnInit {

  @ViewChild(CreateEditUserComponent, {static: false}) window !: CreateEditUserComponent;

  protected menu: string = 'Acceso';

  protected menuIcon: string = 'gears';

  protected label: string = 'Usuario';

  protected name: string = 'Usuarios';

  protected nameIcon: string = 'user';

  protected table: string = 'users';

  constructor(protected authService: AuthService, protected service: DatasourceService, protected alertService: AlertService) {

    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }

  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];
    s.filter = {
      logic: "and",
      filters: [
        {
          field: 'id',
          operator: 'neq',
          value: this.currentUser.id
        }
      ]
    }

    return s;

  }

  ngOnInit() { 

    super.ngOnInit();

  }

}